/**
 * StackStep's meeting-recorder multi-select list. Recorder selections just
 * live in flow state — no network status to track here.
 */
import { useMemo } from 'react';

import { CARD_BORDER } from '@/lib/base/list-card';
import { SelectableRow } from '@/lib/self-service/components/SelectableRow';
import { RECORDER_OPTIONS } from '@/lib/self-service/constants';
import { cx } from '@/utils/cx';

const CARD_CLASSES = cx(CARD_BORDER, 'bg-bg-primary');

export interface StackStepRecorderSelectionsProps {
  selectedIds: string[];
  onToggle: (id: string) => void;
}

export function StackStepRecorderSelections({
  selectedIds,
  onToggle,
}: StackStepRecorderSelectionsProps) {
  const recorderOptionsWithLeading = useMemo(
    () =>
      RECORDER_OPTIONS.map(recorder => ({
        ...recorder,
        leading: (
          <img src={recorder.iconSrc} alt='' className='size-7 shrink-0' />
        ),
      })),
    []
  );

  return (
    <div className='flex flex-col gap-3'>
      <span className='text-sm font-semibold text-[var(--color-text-primary)]'>
        Meeting recorder
      </span>
      {recorderOptionsWithLeading.map(recorder => (
        <div key={recorder.id} className={CARD_CLASSES}>
          <SelectableRow
            id={recorder.id}
            leading={recorder.leading}
            title={recorder.name}
            subtitle={recorder.description}
            isSelected={selectedIds.includes(recorder.id)}
            onToggle={onToggle}
          />
        </div>
      ))}
    </div>
  );
}
